import { useEffect, useState } from 'react'
import { Banner } from './Banners'

import Advertisement_1 from '../Assets/Advertisement/1.png'
import Advertisement_2 from '../Assets/Advertisement/2.png'
import Advertisement_3 from '../Assets/Advertisement/3.png'
import Advertisement_4 from '../Assets/Advertisement/4.png'
import { useRequestGet } from '../Hooks'


export const Commercial = ({enableBanner = false, percent, comercial}) => {


    const {data, isLoading, isError} =  useRequestGet('banners/?tipo=AN');

    const [banners, setBanners] = useState([]);
  
    useEffect(() => {
      try {
        if (data) {
          setBanners( () => JSON.parse(data)?.results )
        }
      } catch (error) {
        console.log(error);
      }
    }, [data])

    if (enableBanner) {

        return (
            <>
                <Banner
                    contentArray={
                    banners?.map( (banner) => (
                        <span
                            key={banner.uuid}
                        >
                            <img src={banner?.image} alt='' className='img-fluid' />
                        </span>
    
                    ))
                    }
                    slidesPerView={1}
                    autoplay={true}
                />
            </>
        )

    }


    return (
        <div 
            className='leyenda'
            style={{ 
                backgroundColor: 'red',
                backgroundImage: ''
             }}
        >
            <div className='row p-5'>
                <div className='col-4'>
                    <h3 className='title text-center' style={{ fontSize: '5rem', color: 'white' }}>
                        {percent}
                    </h3>
                </div>
                <div className='col-8'>
                    <h4 className='title fs-1 text-center m-auto text-wrap' style={{ color: 'white' }}>
                        {comercial}
                    </h4>
                </div>
            </div>
        </div>
    )
}
